export const cvFiles = [
    {
      preview: "/assets/files/cv/de.png",
      pdf: "/assets/files/cv/Deutsch2025.pdf",
      name: "СV(Deutsch)",
    },
    {
      preview: "/assets/files/cv/eng.png",
      pdf: "/assets/files/cv/English2025.pdf",
      name: "CV(English)",
    },
  ];
  
  
  export const recommendationFiles = [
    {
      preview: "/assets/files/recom/herren.png",
      pdf: "/assets/files/recom/RecommendationLetter12/06/24.pdf",
      name: "Recommendation Letter Berlin",
    },
    {
      preview: "/assets/files/recom/tailbook.png",
      pdf: "/assets/files/recom/RecommendationLetter10/17/2024.pdf",
      name: "Recommendation Letter Montenegro",
    },
    {
      preview: "/assets/files/recom/Kunst.png",
      pdf: "/assets/files/recom/RecommendationLetter11/Kunstschule.pdf",
      name: "Recommendation Letter Kunstschule Berlin",
    },
  ];
  
  export const certificateFiles = [
    {
      preview: "/assets/files/zertifikat/diplom.png",
      pdf: "/assets/files/zertifikat/DiplomEl.pdf",
      name: "Diplom",
    },
    {
      preview: "/assets/files/zertifikat/it_de.png",
      pdf: "/assets/files/zertifikat/IT_de.pdf",
      name: "IT Certificate ",
    },
    {
      preview: "/assets/files/zertifikat/it_en.png",
      pdf: "/assets/files/zertifikat/IT_en.pdf",
      name: "IT Certificate ",
    },
    {
      preview: "/assets/files/zertifikat/eva_1.png",
      pdf: "/assets/files/zertifikat/Eva-zertifikat-html.pdf",
      name: "Eva Certificate 1 ",
    },
    {
      preview: "/assets/files/zertifikat/eva_2.png",
      pdf: "/assets/files/zertifikat/Eva-zertifikat-webphp.pdf",
      name: "Eva Certificate 2 ",
    },
    
  ];
  